import { Box, IconButton, LinearProgress, Modal, TextField, Typography, Paper } from '@mui/material';
import './styles.scss'
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { DynSort } from './sort_dyn';
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { updateFieldVariablesValues } from 'src/shared/util/updateDataServer';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "src/stateManagement/redux";
import { loadLocationDetails } from 'src/stateManagement/redux/slices/location/asyncReducers';
import { useParams } from 'react-router-dom';

export const ModalVariables = ({ sortDyns, open, onClose, showAsModal = true }: { sortDyns: DynSort, open: any, onClose: any, showAsModal?: boolean }) => {

    const [loading, setloading] = useState(false)

    const dispatch = useDispatch();

    const { id } = useParams();

    const VariablesToshow = [
        { variable: "Hora Entrada" },
        { variable: "Hora Salida" },
        { variable: "Sector" },
        { variable: "Tecnologia" },
        { variable: "Tipo Actividad" },
        { variable: "POT" },
        { variable: "Estado Pozo Inicial" },
        { variable: "Estado Pozo Final" },
        { variable: "THP" },
        { variable: "Marca Balancin" },
        { variable: "Modelo Balancin" },
        { variable: "Barra Libre" },
        { variable: "Carrera" },
        { variable: "SPM", variableIdToEdit: "spm" },
        { variable: "Tiro" },
        { variable: "Carga_max" },
        { variable: "Carga_min" },
        { variable: "Prof Nivel" },
        { variable: "Sumergencia" },
        { variable: "PIP" },
        { variable: "Pwf" },
        { variable: "Maleza" },
        { variable: "Fosa" },
        { variable: "Stuffing" },
        { variable: "Sonolog" },
        { variable: "Valvula 2da de 4" },
        { variable: "Válvula Toma Muestra" },
        { variable: "Frenos" },
        { variable: "Selector" },
        { variable: "Acceso Variador" },
        { variable: "Acceso Cabezal" },
        { variable: "Reespaceo" },
        { variable: "Nivel" },
        { variable: "Prueba Presión" },
        { variable: "Prueba de Válvula" },
        { variable: "Muestras" }
    ]
    const bypassVariables = ["Comentario", "Cuadrilla", "Ingenieros"]

    const [variablesBypassed, setVariablesBypassed] = useState<any>({})

    const [variablesToUpdate, setVariablesToUpdate] = useState<any>(undefined)

    useEffect(() => {

        const variablesBypassed: any = {}

        const newVariablesToUpdate = {
            originFieldActivityIds: [sortDyns?.fieldActivityId],
        }

        setVariablesToUpdate(newVariablesToUpdate)

        sortDyns?.variables.forEach((variable: any) => {
            if (bypassVariables.includes(variable.variable)) {
                variablesBypassed[variable.variable] = variable.value
            }
        })

        setVariablesBypassed(variablesBypassed)

    }, [sortDyns])

    const onSaveDiagnostic = () => {
        setloading(true)
        updateFieldVariablesValues(variablesToUpdate).then((data) => {
            setloading(false)
            Swal.fire({
                title: "Guardado!",
                icon: "success",
            });
            dispatch(loadLocationDetails(id!));
        }
        ).catch((error) => {
            Swal.fire({
                title: "Error!",
                icon: "error",
            });

            setloading(false)
        })
    }

    const onChangeVariables = (value: any, label: any) => {
        const newVariablesToUpdate: any = { ...variablesToUpdate }
        newVariablesToUpdate[label] = value
        setVariablesToUpdate(newVariablesToUpdate)
    }

    const handleClose = () => {
        if (loading) return
        onClose()
    }

    if (!showAsModal) {
        return (
            <Box sx={{ p: 2 }}>
                <Grid>
                    <Typography variant="subtitle1" textAlign={"center"} sx={{ fontWeight: "600", color:"custom.textGrey" }}>
                        {sortDyns.executedDate} |{" "}
                         {variablesBypassed["Ingenieros"]} | C:
                        {variablesBypassed["Cuadrilla"]}
                    </Typography>
                </Grid>
                <Grid className="modal_body">
                    {VariablesToshow.map((variable: any, index: number) => {
                        const variableToShow = sortDyns?.variables.find(
                            (v: any) => v.variable === variable.variable
                        );

                        if (variableToShow) {
                            return (
                                <Grid container key={index}>
                                    <Grid
                                        size={12}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                           
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Typography className="label-input">
                                                {variableToShow.variable}
                                            </Typography>

                                            <TextField
                                                id="variable"
                                                size="small"
                                                onChange={(e) =>
                                                    variable?.variableIdToEdit &&
                                                    onChangeVariables(
                                                        e.target.value,
                                                        variable.variableIdToEdit
                                                    )
                                                }
                                                value={
                                                    variablesToUpdate?.[
                                                        variable
                                                            ?.variableIdToEdit
                                                    ] || variableToShow.value
                                                }
                                                sx={{
                                                    input: {
                                                        textAlign: "center",
                                                    },
                                                    "& .MuiOutlinedInput-root":
                                                        {
                                                            "& fieldset": {
                                                                border: "none",
                                                            },
                                                        },
                                                    backgroundColor: "#f0f0f0", 
                                                    borderRadius: '10px'
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            );
                        }
                    })}
                </Grid>
                <Grid container sx={{ padding: "0px 120px" , mt: "10px"}}>
                    <Grid size={12}>
                        <Paper elevation={3}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    padding: 2,
                                }}
                            >
                                <Typography className="label-input">
                                    Comentario
                                </Typography>

                                <Box>{variablesBypassed["Comentario"] || ""}</Box>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        );
    }


    return (
        <Modal
            open={open}
            onClose={() => handleClose()}
        >
            <Box className="modal_update_card_location">
                {/* headers */}
                <Box className="modal_header" sx={{ 
                        position: "sticky", top: 0, 
                        zIndex: 10, display: "flex", 
                        justifyContent: "space-between", alignItems: "center", 
                        padding: "15px" }}>
                    <IconButton
                        aria-label="delete"
                        size='small'
                        onClick={() => onClose()}
                    >
                        <CloseIcon color="error" />
                    </IconButton>
                    <Typography className='title' id="modal-modal-title" variant="h6" component="h2">
                        Variables de la visita
                    </Typography>
                    <IconButton
                        aria-label="delete"
                        size='small'
                        onClick={() => onSaveDiagnostic()}
                    >
                        <SaveOutlinedIcon color="primary" />
                    </IconButton>
                </Box>
                {loading && (
                    <>
                        <Box className="modal_analyst_loading_background" />
                        <Box className="modal__analyst_task_loading">
                            <LinearProgress />
                            Saving....
                        </Box>
                    </>
                )}
                {/* body */}
                <Box sx={{ p: 2, gap: 2 }} >
                    <Grid>
                        <Typography variant="subtitle1" textAlign={"center"}>
                            {sortDyns.executedDate} - {variablesBypassed["Ingenieros"]} - C:{variablesBypassed["Cuadrilla"]}
                        </Typography>
                    </Grid>
                    <Grid className="modal_body" sx={{ gap: 2 }}>
                        {VariablesToshow.map((variable: any, index: number) => {

                            const variableToShow = sortDyns?.variables.find((v: any) => v.variable === variable.variable)

                            if (variableToShow) {

                                return (
                                    <Grid key={index} >
                                        <Grid>
                                            <TextField
                                                id="variable"
                                                size="small"
                                                onChange={(e) => variable?.variableIdToEdit && onChangeVariables(e.target.value, variable.variableIdToEdit)}
                                                label={variableToShow.variable}
                                                value={variablesToUpdate?.[variable?.variableIdToEdit] || variableToShow.value}
                                                fullWidth
                                                sx={{
                                                    backgroundColor: variable?.variableIdToEdit ? 'white' : '#f5f5f5',
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                )
                            }
                        })}
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid size={12}>
                            <TextField
                                id="variable"
                                size="small"
                                label={"Comentario"}
                                value={variablesBypassed["Comentario"] || ""}
                                fullWidth
                                multiline
                            />
                        </Grid>
                    </Grid>

                </Box>
            </Box>
        </Modal>
    )
}